export const themes = {
  default: {
    name: "NT Dark (Default)",
    colors: {
      primary: "#FF7A1A",
      secondary: "#FF9340",
      background: "#0B0B0C",
      formBg: "#141416",
      sidebar: "#101011",
      sidebarHover: "#19191c",
      sidebarActive: "#FF7A1A",
      inputBorder: "#FF7A1A",
      text: "#F7F7F7",
      textLight: "#BDBDBD",
      white: "#ffffff",
      shadow: "rgba(255, 122, 26, 0.15)",
      border: "rgba(255, 255, 255, 0.08)",
      success: "#22C55E",
      warning: "#EAB308",
      error: "#EF4444",
      info: "#3B82F6",
      boxLight: "#19191c",
    },
  },
  skyBlue: {
    name: "Sky Blue",
    colors: {
      primary: "#0c4a6e",
      secondary: "#e0f2fe",
      background: "#f0f9ff",
      formBg: "#f8fbff",
      sidebar: "#0c4a6e",
      sidebarHover: "#0369a1",
      sidebarActive: "#0284c7",
      inputBorder: "#0284c7",
      text: "#0c4a6e",
      textLight: "#38bdf8",
      white: "#ffffff",
      shadow: "rgba(0,0,0,0.1)",
      border: "#7dd3fc",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      info: "#3b82f6",
      boxLight: "#f4f9ff",
    },
  },
  tropicalVibe: {
    name: "Tropical Vibe",
    colors: {
      primary: "#03A6A1",
      secondary: "#FFE3BB",
      background: "#FFF9F5",
      formBg: "#fdfaf7",
      sidebar: "#03A6A1",
      sidebarHover: "#04C4BE",
      sidebarActive: "#028B86",
      inputBorder: "#028B86",
      text: "#2A2A2A",
      textLight: "#6B7280",
      white: "#FFFFFF",
      shadow: "rgba(3, 166, 161, 0.2)",
      border: "#FFE3BB",
      success: "#03A6A1",
      warning: "#FFA673",
      error: "#FF4F0F",
      info: "#3B82F6",
      accent1: "#FFA673",
      accent2: "#FF4F0F",
      accent3: "#FFE3BB",
      boxLight: "#f7fafc",
    },
  },
  biophilicHarmony: {
    name: "Biophilic Harmony",
    colors: {
      primary: "#2A3335",
      secondary: "#0A5E80",
      background: "#F9F9F9",
      formBg: "#f7f9f9",
      sidebar: "#2A3335",
      sidebarHover: "#0A5E80",
      sidebarActive: "#0A9780",
      inputBorder: "#0A9780",
      text: "#2A3335",
      textLight: "#5A6D72",
      white: "#FFFFFF",
      shadow: "rgba(10, 94, 128, 0.15)",
      border: "#D1E0E5",
      success: "#0A9780",
      warning: "#FFA073",
      error: "#E74C3C",
      info: "#0A5E80",
      accent1: "#FFCFEF",
      accent2: "#0A9780",
      accent3: "#2A3335",
      boxLight: "#f3f7f5",
    },
  },
  jewelTones: {
    name: "Jewel Tones",
    colors: {
      primary: "#210F37",
      secondary: "#210F37",
      background: "#F8F4F0",
      formBg: "#faf9fc",
      sidebar: "#210F37",
      sidebarHover: "#3A1B4D",
      sidebarActive: "#4F1C51",
      inputBorder: "#4F1C51",
      text: "#210F37",
      textLight: "#6D6D7A",
      white: "#ffffff",
      shadow: "rgba(33, 15, 55, 0.15)",
      border: "#DCA06D",
      success: "#4A7C59",
      warning: "#A55B4B",
      error: "#9E2B2B",
      info: "#4B6A9E",
      accent1: "#A55B4B",
      accent2: "#DCA06D",
      boxLight: "#f7f4fa",
    },
  },
  oceanAqua: {
    name: "Ocean Aqua",
    colors: {
      primary: "#06b6d4",
      secondary: "#a7f3d0",
      background: "#f0fdfa",
      formBg: "#f6fffe",
      sidebar: "#06b6d4",
      sidebarHover: "#14b8a6",
      sidebarActive: "#0e7490",
      inputBorder: "#0e7490",
      text: "#134e4a",
      textLight: "#67e8f9",
      white: "#ffffff",
      shadow: "rgba(0,0,0,0.08)",
      border: "#99f6e4",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      info: "#3b82f6",
      boxLight: "#eafaf7",
    },
  },
  oceanWave: {
    name: "Ocean Wave",
    colors: {
      primary: "#0ea5e9",
      secondary: "#bae6fd",
      background: "#e0f2fe",
      formBg: "#f5faff",
      sidebar: "#0ea5e9",
      sidebarHover: "#38bdf8",
      sidebarActive: "#0369a1",
      inputBorder: "#0369a1",
      text: "#0c4a6e",
      textLight: "#7dd3fc",
      white: "#ffffff",
      shadow: "rgba(0,0,0,0.08)",
      border: "#7dd3fc",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      info: "#3b82f6",
      boxLight: "#f2faff",
    },
  },
  pink: {
    name: "Rose Pink",
    colors: {
      primary: "#831843",
      secondary: "#fce7f3",
      background: "#fdf2f8",
      formBg: "#fff9fb",
      sidebar: "#831843",
      sidebarHover: "#9d174d",
      sidebarActive: "#be185d",
      inputBorder: "#be185d",
      text: "#be185d",
      textLight: "#ec4899",
      white: "#ffffff",
      shadow: "rgba(0,0,0,0.1)",
      border: "#fbcfe8",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      info: "#3b82f6",
      boxLight: "#fff6fa",
    },
  },
  emerald: {
    name: "Emerald Green",
    colors: {
      primary: "#064e3b",
      secondary: "#d1fae5",
      background: "#ecfdf5",
      formBg: "#f5fff9",
      sidebar: "#064e3b",
      sidebarHover: "#047857",
      sidebarActive: "#059669",
      inputBorder: "#059669",
      text: "#065f46",
      textLight: "#34d399",
      white: "#ffffff",
      shadow: "rgba(0,0,0,0.1)",
      border: "#a7f3d0",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      info: "#3b82f6",
      boxLight: "#f3fcf7",
    },
  },
  sky: {
    name: "Blue",
    colors: {
      primary: "#1e40af",
      secondary: "#cfe8fc",
      background: "#F2F7F8",
      formBg: "#fcfdfe",
      sidebar: "#1e40af",
      sidebarHover: "#447aee",
      sidebarActive: "#2563eb",
      inputBorder: "#2563eb",
      text: "#15395A",
      textLight: "#8a8fa3",
      white: "#ffffff",
      shadow: "rgba(0,0,0,0.1)",
      border: "#d0defb",
      success: "#10b981",
      warning: "#f59e0b",
      error: "#ef4444",
      info: "#3b82f6",
      boxLight: "#f9f9fb",
    },
  },
};

// Default theme
export const defaultTheme = "default";

// Theme utility functions
export const getTheme = (themeName) => {
  return themes[themeName] || themes[defaultTheme];
};

export const getAllThemes = () => {
  return Object.keys(themes).map((key) => ({
    key,
    ...themes[key],
  }));
};
